import { render, staticRenderFns } from "./AdminUserPassword.vue?vue&type=template&id=0fe036c8"
import script from "./AdminUserPassword.vue?vue&type=script&lang=ts"
export * from "./AdminUserPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports